import { FlagsFilterValueBase } from "abweb/dto/generated/inputargs/FlagsFilterValueBase";
export class FlagsFilterValue extends FlagsFilterValueBase {
  static createFlagsFilterValue(selectedFlagIDs) {
    const retVal = new FlagsFilterValue();
    retVal.initFlagsFilterValue(null, selectedFlagIDs);
    return retVal;
  }
  constructor() {
    super();
    this.initFlagsFilterValue(null, []);
  }
  clone() {
    return FlagsFilterValue.createFlagsFilterValue(this.selectedFlagIDs);
  }
}
//# sourceMappingURL=FlagsFilterValue.js.map
